import React, { useEffect, useState } from 'react'
import { Table } from 'antd'

const subsystemsTableColumns = [
  {
    title: 'Sub System',
    dataIndex: 'subsystem',
    sorter: (a, b) => a.subsystem.localeCompare(b.subsystem),
  },
  {
    title: 'minutes',
    dataIndex: 'timeSpent',
    render: (value) => {
      let dispVal = Number.isInteger(value) ? value : Math.round(value)
      if (dispVal < 1) {
        return '< 1m'
      }
      return dispVal
    },
    sorter: (a, b) => a.timeSpent - b.timeSpent,
    defaultSortOrder: 'descend',
  },
]

const TimeSpentOnSubsystem = ({ data, selectedUser }) => {
  const [groupData, updateGroupedData] = useState([])

  useEffect(() => {
    if (!data || data.length === 0) {
      updateGroupedData([])
      return
    }
    const groupedData = []
    data.forEach((record) => {
      if (selectedUser && record.userId !== selectedUser) {
        return
      }
      const key = record.eventData.subsystem
      if (!groupedData[key]) {
        groupedData[key] = {
          subsystem: record.eventData.subsystem,
          timeSpent: record.eventData.timeOnSubsystem,
        }
      } else {
        groupedData[key].timeSpent += record.eventData.timeOnSubsystem
      }
    })
    updateGroupedData(
      Object.values(groupedData).map((row) => {
        let minutes = Math.round(row.timeSpent / 60000)
        return {
          ...row,
          timeSpent: minutes === 0 ? 0.1 : minutes,
        }
      }),
    )
  }, [data, selectedUser])

  if (!Array.isArray(groupData) || groupData.length === 0) {
    return null
  }
  return (
    <Table
      size="small"
      dataSource={groupData}
      columns={subsystemsTableColumns}
      data-testid="subsystem-table"
      pagination={{
        pageSize: 3,
        hideOnSinglePage: true,
      }}
    />
  )
}

export default TimeSpentOnSubsystem
